import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Self-hosted fonts (no Google Fonts CDN — keeps visitor IPs off Google's servers).
// JetBrains Mono is the global UI font; weight files bundle all subsets incl. greek (Λ in "NΛSOS").
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import '@fontsource/jetbrains-mono/700.css';
// Crimson Text (italic 600) is used for AOTD pull-quotes.
import '@fontsource/crimson-text/600-italic.css';
import './utils/leafletDefaultIcons';
import './utils/pwa'; // capture beforeinstallprompt/appinstalled as early as possible
import './api';
import App from './App';
// import reportWebVitals from './reportWebVitals';

import { Provider } from "react-redux";
import { store } from "./store/store";

// dev only: the CRA error overlay treats the benign "ResizeObserver loop
// completed with undelivered notifications" browser warning as a runtime crash
// and blacks out the page (chat panel / AOTD resizes trigger it constantly).
// The dev-server client registers its error listener before app code runs, so
// stopping propagation isn't enough — hide the overlay iframe when this exact
// message is the trigger. Production builds strip this whole block.
if (process.env.NODE_ENV === 'development') {
  const isBenignResizeObserverError = (msg) =>
    typeof msg === 'string' && msg.includes('ResizeObserver loop');
  window.addEventListener('error', (e) => {
    if (!isBenignResizeObserverError(e.message)) return;
    e.stopImmediatePropagation();
    // the overlay may already be mounted (or mounts a tick later) — hide it
    const hideOverlay = () => {
      const overlay = document.getElementById('webpack-dev-server-client-overlay');
      if (overlay) overlay.style.display = 'none';
    };
    hideOverlay();
    setTimeout(hideOverlay, 0);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[SW] registration failed', err);
    });
  });
}
